import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { Button, Input, Select, DatePicker } from "antd";
import { CustomLabel } from "../../../utilities/utll";
import {
  DownCircleOutlined,
  FilterOutlined,
  FilterTwoTone,
  ReloadOutlined,
  SaveOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import { useBarCodeMasterStore } from "../../../store/useBarCodeStore";

export const FilterMode = () => {
  const { getDepartment, department, getCategory, category } =
    useVendorMasterStore();

  const {
    formData,
    errors,
    handleInputChange,
    fetchDepartment,
    submitFilter,
    fetchListOnLoad,
  } = useBarCodeMasterStore();

  useEffect(() => {
    getCategory();
    fetchListOnLoad();
  }, []);
  return (
    <>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Divison"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={[
              { label: "All", value: 0 },
              ...(Array.isArray(category)
                ? category.map((item) => ({
                    label: item.DivisionName,
                    value: item.Division,
                  }))
                : []),
            ]}
            value={formData?.divisionCode}
            onChange={(val, option) => {
              handleInputChange("divisionCode", val);
              handleInputChange("divisionName", option?.label);
              handleInputChange("departmentName", null);
              handleInputChange("departmentCode", null);
              fetchDepartment(val, getDepartment);
            }}
          />
          {errors?.divisionCode && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.divisionCode}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Department"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={[
              { label: "All", value: 0 },
              ...department.map((d) => ({
                label: d.DepartmentName,
                value: d.Department,
              })),
            ]}
            value={formData.departmentCode}
            onChange={(val, opt) => {
              handleInputChange("departmentCode", val);
              handleInputChange("departmentName", opt.label);
            }}
          />
          
        </Col>
        {/* <Col xl={2} md={6}>
          <CustomLabel children={"From Date"} isImportnt={false} />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
          />
        </Col>

        <Col xl={2} md={6}>
          <CustomLabel children={"To Date"} isImportnt={false} />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
          />
        </Col> */}

        <Col xl={2} style={{ textAlign: "center", marginTop: "1rem" }}>
          <Button
            type="primary"
            icon={<FilterOutlined />}
            size="large"
            style={{
              marginRight: "0.75rem",
              backgroundColor: "#64c41aff", // elegant green
              borderColor: "#69c41aff",
              boxShadow: "0 2px 6px rgba(2, 2, 65, 0.3)",
            }}
            onClick={() => submitFilter()}
          >
            Search
          </Button>
        </Col>
      </Row>
    </>
  );
};
